import React, { useState, useRef, useEffect } from 'react';
import api from '../api';

function PinGate({ children }) {
  const [unlocked, setUnlocked] = useState(false);
  const [pin, setPin] = useState(['', '', '', '']);
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(false);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  useEffect(() => {
    // Check if already unlocked this session
    if (sessionStorage.getItem('diary_unlocked') === 'true') {
      setUnlocked(true);
    }
  }, []);

  useEffect(() => {
    // Auto-submit when all 4 digits entered
    const fullPin = pin.join('');
    if (fullPin.length === 4) {
      verifyPin(fullPin);
    }
  }, [pin]);

  const verifyPin = async (fullPin) => {
    setChecking(true);
    setError('');
    try {
      const { data } = await api.post('/verify-pin', { pin: fullPin });
      if (data.success) {
        sessionStorage.setItem('diary_unlocked', 'true');
        setUnlocked(true);
      }
    } catch (err) {
      setError('wrong pin');
      setPin(['', '', '', '']);
      setTimeout(() => inputRefs[0].current?.focus(), 100);
      setTimeout(() => setError(''), 2000);
    } finally {
      setChecking(false);
    }
  };

  const handleChange = (index, value) => {
    // Only allow numeric
    if (value && !/^\d$/.test(value)) return;

    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    // Auto-focus next input
    if (value && index < 3) {
      inputRefs[index + 1].current?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !pin[index] && index > 0) {
      inputRefs[index - 1].current?.focus();
      const newPin = [...pin];
      newPin[index - 1] = '';
      setPin(newPin);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 4);
    if (pasted.length === 4) {
      setPin(pasted.split(''));
    }
  };

  if (unlocked) return children;

  return (
    <div className="pin-gate">
      <div className="pin-card">
        <div className="pin-icon">.</div>
        <h1 className="pin-title">inside me</h1>
        <p className="pin-subtitle">enter pin to continue</p>

        <div className="pin-inputs">
          {pin.map((digit, i) => (
            <input
              key={i}
              ref={inputRefs[i]}
              type="tel"
              inputMode="numeric"
              maxLength={1}
              value={digit}
              onChange={(e) => handleChange(i, e.target.value)}
              onKeyDown={(e) => handleKeyDown(i, e)}
              onPaste={i === 0 ? handlePaste : undefined}
              className={`pin-digit ${error ? 'pin-error' : ''} ${digit ? 'pin-filled' : ''}`}
              autoFocus={i === 0}
              disabled={checking}
            />
          ))}
        </div>

        {error && <div className="pin-error-msg">{error}</div>}
        {checking && <div className="pin-checking">verifying...</div>}
      </div>
    </div>
  );
}

export default PinGate;
